import { isSet } from '../utils/isSet';
import { Layer } from './Layer';

class FloatingCTA {
    constructor(root){
        this.root = root;
        this.headerElm = document.querySelector('.block--header');
        this.switchElm = document.querySelector('.floating-cta-switch');
        this.hideElm = this.root.querySelector('[layer-close]');

        this.init();
    }

    init(){
        this.init__layer();

        this.hideElm.addEventListener('click', this.hideElmClickHandler.bind(this));
        this.switchElm.addEventListener('click', this.switchElmClickHandler.bind(this));

        this.observer = new IntersectionObserver(
            this.handleIntersection.bind(this),
            {
                threshold: 0.5
            }
        );

        this.observer.observe(this.headerElm);
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.5) {
                this.handleHeaderIsVisible();
            } else {
                this.handleHeaderIsHidden();
            }
        });
    }

    hideElmClickHandler(){
        this.wasHidden = true;
    }

    switchElmClickHandler(){
        this.wasHidden = false;
    }

    handleHeaderIsVisible() {
        this.layerAPI.closeLayer();
        this.switchElm.classList.add('hide');
        this.switchElm.classList.remove('show');
    }

    handleHeaderIsHidden() {
        this.switchElm.classList.remove('hide');
        this.switchElm.classList.add('show');

        if(this.wasHidden === true) return;
        this.layerAPI.openLayer();

    }

    init__layer(){
        if(this.layerAPI) return;

        this.layerAPI = new Layer(
            this.root,
            {
                awaitCloseAnimation: true,
                awaitOpenAnimation: true,
                disableScroll: false,
                closeOnBackgroundClick: false,
                closeOnEscClick: false,
                setFocusOnOpen: false
            }
        )
    }

}

export { FloatingCTA }